import { Children, isValidElement, ReactNode } from "react";
import { ChevronRight } from "lucide-react";
import Switch from "../../ui/Switch";
import { useAccordionItemState } from "../../context/ComponentesSlots";
import { twMerge } from "tailwind-merge";
import { TriggerIcon } from "./TriggerIcon";

export type TriggerProps = {
    children?: ReactNode;
    title: string;
};

export const Trigger = ({ children, title }: TriggerProps) => {
    const { isOpen } = useAccordionItemState();

    const triggerIcon = Children.map(children, (child) =>
        isValidElement(child) && child.type === TriggerIcon ? child : null
    );

    const switchElement = Children.map(children, (child) =>
        isValidElement(child) && child.type === Switch ? child : null
    );

    return (
        <div
            role="button"
            tabIndex={0}

            className={twMerge('group-hover/trigger:bg-gray-100 w-full p-2 flex flex-row items-center justify-between [&_svg]:!size-4 [&_svg]:!stroke-[2.3] gap-[6px] rounded-lg !ring-0 !outline-none', `${isOpen ? 'bg-gray-100' : ''}`)}
            aria-expanded={isOpen}
        >
            <div className="flex flex-row items-center gap-[6px]">
                {triggerIcon}
                <p className="!text-gray-900 !font-sans !text-sm !font-normal !leading-5 !tracking-normal !m-0 !p-0 select-none">
                    {title}
                </p>
            </div>

            <div className="flex text-gray-900">
                {switchElement && switchElement.length > 0 ? (
                    switchElement
                ) : (
                    <ChevronRight
                        style={{
                            transform: isOpen ? "rotate(-90deg)" : "rotate(0deg)",
                            transition: "transform 150ms ease",
                        }}
                    />
                )}
            </div>
        </div>
    );
};
